var _rect, _polygon, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _polygon2, _rect18, _circle2, _polygon3, _rect19, _path4, _path5, _path6, _rect20, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle3, _polygon4, _path18, _path19, _path20, _path21, _polygon5, _path22, _circle4, _rect21, _path23, _polygon6, _path24, _polygon7, _circle5, _circle6, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawQualityTimeWiyl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 883.7815,
    height: 672.25367,
    viewBox: "0 0 883.7815 672.25367",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2185,
    y: 606.99638,
    width: 883.56299,
    height: 65.25729,
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "882.556 607.051 0 607.051 0 604.87 882.951 604.87 882.556 607.051",
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M851.298,365.06194v193.1823H348.92048V365.06194A251.19094,251.19094,0,0,1,585.60763,114.28746q7.19385-.41944,14.50162-.4143c2.776,0,5.54167.04141,8.28664.145A250.32942,250.32942,0,0,1,777.723,187.44814c1.357,1.35693,2.6932,2.72423,4.0294,4.11227A251.03573,251.03573,0,0,1,851.298,365.06194Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M608.39589,114.0182v444.226H585.60763V114.28746q7.19385-.41944,14.50162-.4143C602.88527,113.87316,605.65092,113.91457,608.39589,114.0182Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M801.07064,214.34867H399.14786a251.9462,251.9462,0,0,1,19.31826-22.78826H781.75239A251.94772,251.94772,0,0,1,801.07064,214.34867Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 476.90748,
    y: 165.7328,
    width: 178.04883,
    height: 301.42653,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 512.06564,
    y: 216.65602,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 555.45634,
    y: 216.65602,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 598.84704,
    y: 216.65602,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 512.81376,
    y: 278.00149,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 556.20446,
    y: 278.00149,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 599.59516,
    y: 278.00149,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 513.56187,
    y: 339.34697,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 556.95257,
    y: 339.34697,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 600.34327,
    y: 339.34697,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 514.30999,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 557.70069,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 601.09139,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 514.30999,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 557.70069,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 601.09139,
    y: 400.69244,
    width: 26.93216,
    height: 26.93216,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250.52809,
    cy: 345.96177,
    r: 37.11924,
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "250.63 345.962 250.732 345.962 252.568 451.201 248.693 451.201 250.63 345.962",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 411.08477,
    y: 514.49403,
    width: 1.83557,
    height: 6.93436,
    transform: "translate(520.28041 -201.77318) rotate(62.23413)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.65787,
    cy: 291.16612,
    r: 56.44638,
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.813 291.166 359.968 291.166 362.759 451.201 356.867 451.201 359.813 291.166",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 521.48886,
    y: 488.15814,
    width: 2.7913,
    height: 10.54493,
    transform: "translate(557.80082 -312.99083) rotate(62.23413)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M401.34412,351.13985l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07883,6.92629A14.43734,14.43734,0,0,0,401.34412,351.13985Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M501.81963,288.99005l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07884,6.92629A14.43742,14.43742,0,0,0,501.81963,288.99005Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M463.49392,348.03236l9.53553-7.6266c-7.40773-.81727-10.45143,3.22274-11.69709,6.42045-5.78722-2.40307-12.0873.74628-12.0873.74628l19.07884,6.92629A14.43742,14.43742,0,0,0,463.49392,348.03236Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 164.39756,
    y: 421.58281,
    width: 555.20488,
    height: 45.57652,
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.5822,654.09443s-112.306-51.70031-72.853-87.55226S239.5822,654.09443,239.5822,654.09443Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.62748,666.1582s-51.62-169.6065,24.39237-161.49519S237.62748,666.1582,237.62748,666.1582Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.99079,651.11615l2.16658,28.37159.03437.49006a130.35307,130.35307,0,0,0,.67063,13.26586c2.94031,28.939,15.57857,42.12751,30.349,42.12751s26.85842-13.18852,29.79874-42.12751a130.356,130.356,0,0,0,.67062-13.26586l.01721-.3955.00856-.09456,2.17518-28.37159Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.70649,679.48774l-.00856.09456-.01721.3955a130.356,130.356,0,0,1-.67062,13.26586H202.86237a130.35307,130.35307,0,0,1-.67063-13.26586l-.03437-.49006Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M991.00534,654.09443s-112.306-51.70031-72.853-87.55226S991.00534,654.09443,991.00534,654.09443Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M989.05061,666.1582s-51.62-169.6065,24.39237-161.49519S989.05061,666.1582,989.05061,666.1582Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M951.41393,651.11615l2.16658,28.37159.03437.49006a130.35311,130.35311,0,0,0,.67062,13.26586c2.94032,28.939,15.57858,42.12751,30.349,42.12751s26.85843-13.18852,29.79874-42.12751a130.35307,130.35307,0,0,0,.67063-13.26586l.01721-.3955.00855-.09456,2.17518-28.37159Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.12962,679.48774l-.00855.09456-.01721.3955a130.35307,130.35307,0,0,1-.67063,13.26586H954.2855a130.35311,130.35311,0,0,1-.67062-13.26586l-.03437-.49006Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M841.89151,756.80505l-7.36292.8647c-5.81584,3.50648-12.642,4.82649-20.20218,4.55778a6.0584,6.0584,0,0,1-5.132-3.14495h0a6.004,6.004,0,0,1,3.91692-8.70765l5.59465-1.3031,13.49993-13.2034,8.14424-14.73959,11.83011,1.35673,2.46276,18.722h0A14.49192,14.49192,0,0,1,841.89151,756.80505Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M727.21733,747.33326l-7.21645,1.698c-5.37845,4.14629-12.00974,6.23546-19.55132,6.82989a6.0584,6.0584,0,0,1-5.45694-2.53974h0a6.004,6.004,0,0,1,2.89929-9.09723l5.40974-1.93205,11.90765-14.65557L721.6211,712.065h11.90765l4.57987,18.31946h0A14.49193,14.49193,0,0,1,727.21733,747.33326Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M721.30136,713.10082l13.46579,2.07166,21.23452-107.2084,36.772-62.66772,44.54069,182.30608,16.57328,3.10749c-1.85841-102.66356,7.21225-231.91222-13.46579-247.56337l-90.11721,10.3583L710.94306,599.15952Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.4494,
    cy: 178.68068,
    r: 31.0749,
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "671.954 226.329 634.664 232.544 625.342 199.397 652.273 191.111 671.954 226.329",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M845.601,487.28988l-99.43968,9.32247c7.972-27.7204,15.276-55.34331,9.32247-82.8664-7.56022-24.57156-.26306-39.18354,19.68077-50.75567l13.46579-30.03907,36.25405-4.14332,0,0A78.25619,78.25619,0,0,1,835.9919,380.558C830.82605,419.7362,832.2211,456.09141,845.601,487.28988Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#80bd85"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M785.859,255.85269c-10.37095,2.36941-22.17487,5.72663-22.83677,8.84705-10.66833,2.68829-18.72067,9.12766-20.36486,18.94463a5.8793,5.8793,0,0,0,5.89829,6.81817c5.80171-.07473,14.51125-.6304,20.26246-3.03248,16.70684,10.7648,19.51113,38.763,12.21507,57.82087l11.48124-1.0524,11.87807-34.77172,3.03391,33.40489,26.20007-3.46416-3.37468-42.59722a63.46522,63.46522,0,0,0-9.96667-28.14221,23.96606,23.96606,0,0,0-1.87524-2.42946A33.29986,33.29986,0,0,0,785.859,255.85269Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M720.0549,767.48915a3.64951,3.64951,0,0,0,3.58967,4.05234l11.65269.11981a2.48493,2.48493,0,0,0,2.312-2.47891h0a2.48494,2.48494,0,0,0-1.562-2.30721l-3.438-1.37518-5-7h-4a18.32116,18.32116,0,0,0-3.55216,8.96941l-.00219.01974Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M692.1636,767.48915a3.64951,3.64951,0,0,1-3.58967,4.05234l-11.65269.11981a2.48493,2.48493,0,0,1-2.312-2.47891h0a2.48493,2.48493,0,0,1,1.56206-2.30721L679.60925,765.5l5-7h4a18.32106,18.32106,0,0,1,3.55216,8.96941l.00219.01974Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "525.5 644.627 531.5 644.627 552.5 553.627 563.5 645.627 570.5 645.627 580 527.127 531.5 526.627 525.5 644.627",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M656.60925,591.5h8v-19l1.81991-3.63981a5.18356,5.18356,0,0,0-3.84813-7.44145h0a5.18358,5.18358,0,0,0-5.97177,5.1233V591.5Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 412.12684,
    r: 18.5,
    fill: "#ffb8b8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 696.60925,
    y: 535.5,
    width: 19,
    height: 22,
    transform: "translate(1254.10925 979.12684) rotate(-180)",
    fill: "#ffb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M687.60925,643.5c16.81763,10.37839,34.59827,9.36365,53,1l-4-93-21-1-22,3-11,9Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#80bd85"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "509.5 496.627 531.5 479.627 524.5 448.627 511.5 472.627 507.5 468.627 495.5 477.627 509.5 496.627",
    fill: "#80bd85"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M765.26522,553.097l-6.99717,3.87809-9.21047-16.61828-3.35622-2.30132a5.18357,5.18357,0,0,1-.24158-8.37407h0a5.18357,5.18357,0,0,1,7.70676,1.58618l2.8882,5.21112Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "568 467.127 594.551 453.032 608.5 445.627 610.5 433.627 601.5 424.627 590.5 431.627 591.5 439.627 578.5 437.627 568 467.127",
    fill: "#80bd85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 405.12684,
    r: 22,
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 380.12684,
    r: 10,
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M719.6243,502.36044a9.99733,9.99733,0,0,0,12.83441-14.57A9.99422,9.99422,0,1,1,718.238,501.47266,10.02019,10.02019,0,0,0,719.6243,502.36044Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M781.3795,518.36478l.68709,24.048a13.11173,13.11173,0,0,1-11.80171,13.42112h0a13.11172,13.11172,0,0,1-13.96224-16.46762l5.39612-19.96565,15.53745-84.93806-1.03583-49.71984,33.14656-1.03583-6.215,55.93482Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#ffb8b8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M811.41857,388.886a52.381,52.381,0,0,0-37.28988,0l2.07166-41.43322a16.57327,16.57327,0,0,1,16.57327-16.57326h0a16.57326,16.57326,0,0,1,16.57326,16.57326Z",
    transform: "translate(-158.10925 -113.87316)",
    fill: "#80bd85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawQualityTimeWiyl);
export default __webpack_public_path__ + "static/media/undraw_quality_time_wiyl.8aa49dae9bd62a67b050d7ca85d50732.svg";
export { ForwardRef as ReactComponent };